export enum PushlyCookie {
    PLATFORM_COOKIE = '_swptk',
}
